<template>
    <div class="openapi-page">
        <el-card>
            <template #header>
                <div class="page-header"><span>开放订单</span></div>
            </template>
            <el-form :model="search" label-width="90px" class="search-form">
                <el-row :gutter="16">
                    <el-col :span="6"><el-form-item label="订单号"><el-input v-model="search.orderNo" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="业务单号"><el-input v-model="search.requestBizNo" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="AppKey"><el-input v-model="search.appKey" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="商户ID"><el-input v-model="search.merchantId" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="产品编码"><el-input v-model="search.productCode" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6"><el-form-item label="VIN"><el-input v-model="search.vin" clearable @keyup.enter="searchData" /></el-form-item></el-col>
                    <el-col :span="6">
                        <el-form-item label="订单状态">
                            <el-select v-model="search.status" clearable style="width: 100%">
                                <el-option label="已创建" value="CREATED" />
                                <el-option label="处理中" value="PROCESSING" />
                                <el-option label="成功" value="SUCCESS" />
                                <el-option label="失败" value="FAILED" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="扣费状态">
                            <el-select v-model="search.chargeStatus" clearable style="width: 100%">
                                <el-option label="已扣费" value="CHARGED" />
                                <el-option label="已退款" value="REFUNDED" />
                                <el-option label="未扣费" value="NOT_CHARGED" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="创建时间">
                            <el-date-picker v-model="dateRange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="YYYY-MM-DD HH:mm:ss" style="width: 100%" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="search-actions">
                    <el-button type="primary" @click="searchData">查询</el-button>
                    <el-button @click="resetSearch">重置</el-button>
                </div>
            </el-form>
            <el-table :data="tableData" border height="calc(100vh - 385px)" v-loading="state.tableLoading">
                <el-table-column prop="orderNo" label="订单号" min-width="180" show-overflow-tooltip />
                <el-table-column prop="requestBizNo" label="业务单号" min-width="160" />
                <el-table-column prop="appKey" label="AppKey" min-width="200" show-overflow-tooltip />
                <el-table-column prop="merchantId" label="商户ID" min-width="140" />
                <el-table-column prop="productName" label="产品" min-width="150" />
                <el-table-column prop="vin" label="VIN" min-width="180" />
                <el-table-column prop="licensePlate" label="车牌" min-width="100" />
                <el-table-column prop="status" label="订单状态" width="100">
                    <template #default="scope"><el-tag :type="statusType(scope.row.status)">{{ statusText(scope.row.status) }}</el-tag></template>
                </el-table-column>
                <el-table-column prop="chargeStatus" label="扣费状态" width="100">
                    <template #default="scope"><el-tag :type="chargeStatusType(scope.row.chargeStatus)">{{ chargeStatusText(scope.row.chargeStatus) }}</el-tag></template>
                </el-table-column>
                <el-table-column label="实扣金额" width="110"><template #default="scope">{{ chargeAmount(scope.row) }}</template></el-table-column>
                <el-table-column label="售价" width="100"><template #default="scope">{{ yuan(scope.row.salePrice) }}</template></el-table-column>
                <el-table-column label="成本" width="100"><template #default="scope">{{ yuan(scope.row.costPrice) }}</template></el-table-column>
                <el-table-column prop="callbackStatus" label="通知状态" width="100">
                    <template #default="scope"><el-tag :type="callbackType(scope.row.callbackStatus)">{{ callbackText(scope.row.callbackStatus) }}</el-tag></template>
                </el-table-column>
                <el-table-column prop="reportUrl" label="报告地址" min-width="180" show-overflow-tooltip />
                <el-table-column label="报告状态" width="120"><template #default="{ row }">{{ archiveText(row.reportArchive?.status) }}</template></el-table-column>
                <el-table-column label="报告到期时间" min-width="175"><template #default="{ row }">{{ row.reportArchive?.expiresAt || "--" }}</template></el-table-column>
                <el-table-column prop="failReason" label="失败原因" min-width="180" show-overflow-tooltip />
                <el-table-column prop="createTime" label="创建时间" min-width="170" />
                <el-table-column fixed="right" label="操作" width="280">
                    <template #default="{ row }">
                        <el-button size="small" @click="openDetail(row)">详情</el-button>
                        <el-button v-if="canRefund(row)" size="small" type="danger" plain :icon="RefreshLeft" @click="openRefund(row)">退款</el-button>
                        <el-button size="small" :icon="Promotion" :disabled="!canResendCallback(row) || state.resendingId !== null" :loading="state.resendingId === row.id" @click="resendCallback(row)">重推回调</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total, sizes, prev, pager, next" v-model:current-page="pagination.current" v-model:page-size="pagination.size" :total="pagination.total" :page-sizes="pagination.sizes" @current-change="loadData" @size-change="loadData" />
            </div>
        </el-card>

        <el-dialog v-model="detail.visible" title="订单详情" width="min(980px, 94vw)" @closed="stopReportPolling">
            <div class="report-actions">
                <el-button :icon="Refresh" :loading="state.reportLoading" @click="refreshReport">刷新</el-button>
                <el-button :icon="Document" :disabled="!detail.row.reportUrl" @click="openUrl(detail.row.reportUrl)">查看报告</el-button>
                <el-button :icon="Picture" :disabled="!detail.row.reportArchive?.reportImageUrl" @click="openUrl(detail.row.reportArchive.reportImageUrl)">查看图片</el-button>
                <el-button :icon="RefreshRight" :disabled="!canRegenerate" :loading="state.regenerating" @click="regenerate">{{ detail.row.productCode === '50001' ? '重新获取报告' : '重新生成报告' }}</el-button>
                <el-button :icon="RefreshRight" :disabled="!canRetryImage" :loading="state.imageRetrying" @click="retryImage">重试截图</el-button>
                <el-button :icon="Promotion" :disabled="!canResendCallback(detail.row) || state.resendingId !== null" :loading="state.resendingId === detail.row.id" @click="resendCallback(detail.row)">重推回调</el-button>
                <el-button v-if="canRefund(detail.row)" :icon="RefreshLeft" type="danger" plain @click="openRefund(detail.row)">退款</el-button>
            </div>
            <el-descriptions :column="2" border>
                <el-descriptions-item label="订单号">{{ detail.row.orderNo || "--" }}</el-descriptions-item>
                <el-descriptions-item label="业务单号">{{ detail.row.requestBizNo || "--" }}</el-descriptions-item>
                <el-descriptions-item label="订单状态">{{ statusText(detail.row.status) }}</el-descriptions-item>
                <el-descriptions-item label="扣费状态">{{ chargeStatusText(detail.row.chargeStatus) }}</el-descriptions-item>
                <el-descriptions-item label="原扣费金额">{{ chargeAmount(detail.row, 'original') }}</el-descriptions-item>
                <el-descriptions-item label="退款金额">{{ chargeAmount(detail.row, 'refund') }}</el-descriptions-item>
                <el-descriptions-item label="实扣金额">{{ chargeAmount(detail.row) }}</el-descriptions-item>
                <el-descriptions-item label="通知状态">{{ callbackText(detail.row.callbackStatus) }}</el-descriptions-item>
                <el-descriptions-item label="内部订单ID">{{ detail.row.internalOrderId || "--" }}</el-descriptions-item>
                <el-descriptions-item label="内部记录ID">{{ detail.row.internalRecordId || "--" }}</el-descriptions-item>
                <el-descriptions-item label="下游回调地址" :span="2">{{ detail.row.callbackUrl || "未传回调地址，订单结果直接通过查询接口获取" }}</el-descriptions-item>
                <el-descriptions-item label="报告地址" :span="2">{{ detail.row.reportUrl || "--" }}</el-descriptions-item>
                <el-descriptions-item label="报告状态">{{ archiveText(detail.row.reportArchive?.status) }}</el-descriptions-item>
                <el-descriptions-item label="截图状态">{{ imageText(detail.row.reportArchive?.imageStatus) }}</el-descriptions-item>
                <el-descriptions-item label="报告生成时间">{{ detail.row.reportArchive?.generatedAt || "--" }}</el-descriptions-item>
                <el-descriptions-item label="统一到期时间">{{ detail.row.reportArchive?.expiresAt || "--" }}</el-descriptions-item>
                <el-descriptions-item label="文件处理信息" :span="2">{{ detail.row.reportArchive?.lastError || "--" }}</el-descriptions-item>
                <el-descriptions-item label="退款方式">{{ refundRecord?.source === 'MANUAL' ? '手动退款' : refundRecord?.source === 'AUTO' ? '自动退款' : '--' }}</el-descriptions-item>
                <el-descriptions-item label="退款操作人">{{ refundRecord?.operatorId || "--" }}</el-descriptions-item>
                <el-descriptions-item label="实际退款金额">{{ yuan(refundRecord?.amount) }}</el-descriptions-item>
                <el-descriptions-item label="退款时间">{{ refundRecord?.createTime || "--" }}</el-descriptions-item>
                <el-descriptions-item label="退款原因" :span="2">{{ refundRecord?.reason || "--" }}</el-descriptions-item>
                <el-descriptions-item label="原始结果" :span="2"><pre class="json-box">{{ detail.row.rawResult || "--" }}</pre></el-descriptions-item>
            </el-descriptions>
            <div class="callback-section">
                <div class="section-title">报告版本记录</div>
                <el-table :data="reportHistory" border max-height="220">
                    <el-table-column prop="id" label="版本" min-width="180" />
                    <el-table-column label="状态" width="110"><template #default="{ row }">{{ archiveText(row.status) }}</template></el-table-column>
                    <el-table-column prop="expiresAt" label="到期时间" min-width="170" />
                    <el-table-column prop="lastError" label="处理信息" min-width="180" show-overflow-tooltip />
                    <el-table-column label="操作" width="110"><template #default="{ row }">
                        <el-button link type="primary" :disabled="!row.storagePrefix" @click="previewCleanup(row)">清理预演</el-button>
                    </template></el-table-column>
                </el-table>
            </div>

            <div class="callback-section">
                <div class="section-title">
                    <span>下游回调记录</span>
                    <el-button size="small" @click="loadCallbackRecords" :loading="state.callbackLoading">刷新</el-button>
                </div>
                <el-table :data="callbackRecords" border max-height="320" v-loading="state.callbackLoading" empty-text="该订单暂无下游回调记录">
                    <el-table-column prop="callbackUrl" label="回调地址" min-width="220" show-overflow-tooltip />
                    <el-table-column prop="httpStatus" label="HTTP状态" width="100" />
                    <el-table-column label="触发方式" width="100"><template #default="{ row }">{{ callbackSourceText(row.triggerSource) }}</template></el-table-column>
                    <el-table-column prop="operatorId" label="操作人" min-width="140" show-overflow-tooltip />
                    <el-table-column label="结果" width="90">
                        <template #default="{ row }"><el-tag :type="callbackResultType(row.success)">{{ callbackResultText(row.success) }}</el-tag></template>
                    </el-table-column>
                    <el-table-column prop="errorMessage" label="失败原因" min-width="180" show-overflow-tooltip />
                    <el-table-column prop="createTime" label="回调时间" min-width="170" />
                    <el-table-column label="操作" width="90">
                        <template #default="scope"><el-button size="small" link type="primary" @click="openCallbackDetail(scope.row)">查看</el-button></template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>

        <el-dialog v-model="refundDialog.visible" title="开放订单退款" width="min(480px, 94vw)" :close-on-click-modal="!state.refunding" :show-close="!state.refunding">
            <el-descriptions :column="1">
                <el-descriptions-item label="订单号">{{ refundDialog.row.orderNo }}</el-descriptions-item>
                <el-descriptions-item label="原扣费">{{ chargeAmount(refundDialog.row, 'original') }}</el-descriptions-item>
                <el-descriptions-item label="退回账户">商户 {{ refundDialog.row.merchantId }} 的开放平台余额</el-descriptions-item>
            </el-descriptions>
            <el-form label-position="top">
                <el-form-item label="退款原因" required>
                    <el-input v-model="refundDialog.reason" type="textarea" :rows="3" maxlength="500" show-word-limit :disabled="state.refunding" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button :disabled="state.refunding" @click="refundDialog.visible = false">取消</el-button>
                <el-button type="danger" :loading="state.refunding" :disabled="!refundDialog.reason.trim()" @click="submitRefund">确认全额退款</el-button>
            </template>
        </el-dialog>
        <el-dialog v-model="cleanupPreview.visible" title="清理预演结果" width="min(780px, 94vw)">
            <pre class="json-box">{{ cleanupPreview.text }}</pre>
        </el-dialog>

        <el-dialog v-model="callbackDetail.visible" title="回调详情" width="min(860px, 94vw)">
            <el-descriptions :column="2" border>
                <el-descriptions-item label="开放订单号">{{ callbackDetail.row.openApiOrderNo || "--" }}</el-descriptions-item>
                <el-descriptions-item label="AppKey">{{ callbackDetail.row.appKey || "--" }}</el-descriptions-item>
                <el-descriptions-item label="商户ID">{{ callbackDetail.row.merchantId || "--" }}</el-descriptions-item>
                <el-descriptions-item label="HTTP状态">{{ callbackDetail.row.httpStatus || "--" }}</el-descriptions-item>
                <el-descriptions-item label="触发方式">{{ callbackSourceText(callbackDetail.row.triggerSource) }}</el-descriptions-item>
                <el-descriptions-item label="操作人">{{ callbackDetail.row.operatorId || "--" }}</el-descriptions-item>
                <el-descriptions-item label="通知结果">{{ callbackResultText(callbackDetail.row.success) }}</el-descriptions-item>
                <el-descriptions-item label="推送时间">{{ callbackDetail.row.createTime || "--" }}</el-descriptions-item>
                <el-descriptions-item label="回调地址" :span="2">{{ callbackDetail.row.callbackUrl || "--" }}</el-descriptions-item>
                <el-descriptions-item label="请求内容" :span="2"><pre class="json-box">{{ formatJson(callbackDetail.row.requestBody) }}</pre></el-descriptions-item>
                <el-descriptions-item label="响应内容" :span="2"><pre class="json-box">{{ formatJson(callbackDetail.row.responseBody) }}</pre></el-descriptions-item>
                <el-descriptions-item label="失败原因" :span="2">{{ callbackDetail.row.errorMessage || "--" }}</el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </div>
</template>

<script setup>
import { reactive, ref, computed, onMounted, onBeforeUnmount } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { Refresh, RefreshLeft, RefreshRight, Document, Picture, Promotion } from "@element-plus/icons-vue";
import { getOpenApiCallbackRecordPage, getOpenApiOrderPage, refundOpenApiOrder, getOpenApiOrderRefund,
    getOpenApiOrderReport, regenerateOpenApiReport, retryOpenApiReportImage,
    getOpenApiReportHistory, previewOpenApiReportCleanup, resendOpenApiOrderCallback } from "@/api/openapi";
import { billingAmounts, chargeStatusText, chargeStatusType } from "./billing-display";

const emptySearch = () => ({ orderNo: "", requestBizNo: "", appKey: "", merchantId: "", productCode: "", vin: "", status: "", chargeStatus: "" });
const search = reactive(emptySearch());
const dateRange = ref([]);
const state = reactive({ tableLoading: false, callbackLoading: false, reportLoading: false,
    refunding: false, regenerating: false, imageRetrying: false, resendingId: null });
const tableData = ref([]);
const callbackRecords = ref([]);
const pagination = reactive({ current: 1, size: 20, total: 0, sizes: [20, 50, 100] });
const detail = reactive({ visible: false, row: {} });
const callbackDetail = reactive({ visible: false, row: {} });
const refundDialog = reactive({ visible: false, row: {}, reason: "" });
const refundRecord = ref(null);
const reportHistory = ref([]);
const cleanupPreview = reactive({ visible: false, text: "" });
let reportTimer;
let pollCount = 0;
const canRefund = (row) => row?.env === "PROD" && row?.chargeStatus === "CHARGED";
const canResendCallback = (row) => ["SUCCESS", "FAILED"].includes(row?.status) && Boolean(row?.callbackUrl?.trim());
const callbackSourceText = (source) => source === "MANUAL" ? "手动重推" : "自动通知";
const callbackResultText = (success) => success === 1 ? "成功" : success === -1 ? "待确认" : "失败";
const callbackResultType = (success) => success === 1 ? "success" : success === -1 ? "warning" : "danger";
const archiveText = (status) => ({ PENDING: "生成中", READY: "有效", EXPIRED: "报告已过期", FAILED: "生成失败", SHARED: "固定测试报告" }[status] || "历史报告");
const imageText = (status) => ({ PENDING: "等待截图", GENERATING: "截图中", READY: "已生成", FAILED: "截图失败", EXPIRED: "已过期", SKIPPED: "无需截图" }[status] || "--");
const canRegenerate = computed(() => detail.row.status === "SUCCESS"
    && ["FAILED", "EXPIRED"].includes(detail.row.reportArchive?.status));
const canRetryImage = computed(() => detail.row.reportArchive?.status === "READY"
    && ["FAILED", "PENDING", "GENERATING"].includes(detail.row.reportArchive?.imageStatus));

function openUrl(url) {
    if (!url || !/^https?:\/\//i.test(url)) return;
    window.open(url, "_blank", "noopener,noreferrer");
}
function openRefund(row) {
    refundDialog.row = row;
    refundDialog.reason = "";
    refundDialog.visible = true;
}
async function resendCallback(row) {
    if (!canResendCallback(row) || state.resendingId !== null) return;
    const { id, orderNo, callbackUrl, callbackStatus } = row;
    state.resendingId = id;
    try {
        await ElMessageBox.confirm(
            `${callbackStatus === "SUCCESS" ? "该订单曾通知成功，再次推送可能产生重复通知。" : ""}`
            + `确认将订单 ${orderNo} 的已保存结果重推到 ${callbackUrl}？本次仅推送一次，不重新查询或扣费。`,
            "重推回调", { confirmButtonText: "确认重推", cancelButtonText: "取消", type: "warning" }
        );
    } catch {
        state.resendingId = null;
        return;
    }
    try {
        const res = await resendOpenApiOrderCallback(id);
        if (res.data?.success === 1) ElMessage.success("回调已重推，下游已确认接收");
        else ElMessage.error(res.data?.errorMessage || "下游未确认接收，请查看回调记录后再决定是否重推");
    } catch (error) {
        if (error?.code == null && !error?.isAxiosError) {
            ElMessage.error(error?.msg || error?.message || "未能确认重推结果，请先查看回调记录和下游接收情况");
        }
    } finally {
        state.resendingId = null;
        const refreshes = [loadData()];
        if (detail.visible && detail.row.id === id) refreshes.push(loadCallbackRecords(), refreshReport());
        await Promise.allSettled(refreshes);
    }
}
async function submitRefund() {
    if (state.refunding || !refundDialog.reason.trim()) return;
    state.refunding = true;
    try {
        const res = await refundOpenApiOrder({ orderId: refundDialog.row.id, reason: refundDialog.reason.trim() });
        Object.assign(refundDialog.row, res.data);
        refundDialog.visible = false;
        ElMessage.success("退款已处理，请查看开放平台余额流水");
        loadData();
        if (detail.visible) await refreshReport();
    } finally { state.refunding = false; }
}
function stopReportPolling() { clearTimeout(reportTimer); }
async function refreshReport() {
    const id = detail.row.id;
    if (!id || state.reportLoading) return;
    stopReportPolling();
    state.reportLoading = true;
    try {
        const [report, refund, history] = await Promise.all([
            getOpenApiOrderReport(id), getOpenApiOrderRefund(id), getOpenApiReportHistory(id)
        ]);
        if (detail.row.id !== id || !detail.visible) return;
        detail.row = report.data;
        refundRecord.value = refund.data;
        reportHistory.value = history.data || [];
        if (["PENDING", "GENERATING"].includes(detail.row.reportArchive?.imageStatus) && pollCount++ < 60) {
            reportTimer = setTimeout(() => refreshReport().catch(() => stopReportPolling()), 5000);
        }
    } finally { state.reportLoading = false; }
}
async function regenerate() {
    try {
        await ElMessageBox.confirm(detail.row.productCode === "50001"
            ? "仅重新获取原供应商报告；源链接失效时无法恢复。确认继续？"
            : "按原查询数据重新生成报告，成功后重新保留三个自然月。确认继续？", "重建报告");
    } catch { return; }
    state.regenerating = true;
    try {
        const res = await regenerateOpenApiReport(detail.row.id);
        if (res.data?.status === "FAILED") ElMessage.error(res.data.lastError || "重建失败");
        else ElMessage.success("报告已生成，截图将异步更新");
        pollCount = 0;
        await refreshReport();
        loadData();
    } finally { state.regenerating = false; }
}
async function retryImage() {
    state.imageRetrying = true;
    try {
        await retryOpenApiReportImage(detail.row.id);
        ElMessage.success("截图任务已受理");
        pollCount = 0;
        await refreshReport();
    } finally { state.imageRetrying = false; }
}
async function previewCleanup(row) {
    const res = await previewOpenApiReportCleanup(row.id);
    cleanupPreview.text = JSON.stringify(res.data, null, 2);
    cleanupPreview.visible = true;
}

const yuan = (cent) => cent === null || cent === undefined ? "-" : "¥" + (cent / 100).toFixed(2);
const chargeAmount = (row, kind = "net") => yuan(billingAmounts(row.chargeStatus, row.salePrice)[kind]);
const statusText = (status) => ({ CREATED: "已创建", SUCCESS: "成功", FAILED: "失败", PROCESSING: "处理中" }[status] || "未知");
const statusType = (status) => ({ CREATED: "info", SUCCESS: "success", FAILED: "danger", PROCESSING: "warning" }[status] || "info");
const callbackText = (status) => ({ SUCCESS: "通知成功", FAILED: "通知失败", SENDING: "通知中", NONE: "无回调" }[status] || (status ? "未知" : "无回调"));
const callbackType = (status) => ({ SUCCESS: "success", FAILED: "danger", SENDING: "warning", NONE: "info" }[status] || "info");

function params() {
    return { ...search, current: pagination.current, size: pagination.size, startTime: dateRange.value?.[0], endTime: dateRange.value?.[1] };
}

function loadData() {
    state.tableLoading = true;
    return getOpenApiOrderPage(params()).then((res) => {
        tableData.value = res.data.records || [];
        pagination.total = res.data.total || 0;
    }).finally(() => state.tableLoading = false);
}

function searchData() {
    pagination.current = 1;
    loadData();
}

function resetSearch() {
    Object.assign(search, emptySearch());
    dateRange.value = [];
    searchData();
}

function openDetail(row) {
    stopReportPolling();
    pollCount = 0;
    detail.row = row;
    detail.visible = true;
    callbackRecords.value = [];
    refundRecord.value = null;
    reportHistory.value = [];
    loadCallbackRecords();
    refreshReport().catch(() => stopReportPolling());
}

function loadCallbackRecords() {
    const orderNo = detail.row.orderNo;
    if (!orderNo) {
        callbackRecords.value = [];
        return;
    }
    state.callbackLoading = true;
    return getOpenApiCallbackRecordPage({ openApiOrderNo: orderNo, current: 1, size: 20 }).then((res) => {
        if (detail.row.orderNo === orderNo) callbackRecords.value = res.data.records || [];
    }).finally(() => state.callbackLoading = false);
}

function openCallbackDetail(row) {
    callbackDetail.row = row;
    callbackDetail.visible = true;
}

function formatJson(value) {
    if (!value) return "--";
    try {
        return JSON.stringify(JSON.parse(value), null, 2);
    } catch (e) {
        return value;
    }
}

onMounted(loadData);
onBeforeUnmount(stopReportPolling);
</script>

<style lang="scss" scoped>
.openapi-page { padding: 16px; }
.page-header { font-weight: 600; }
.search-form { margin-bottom: 12px; }
.search-actions { text-align: right; }
.pagination-box { margin-top: 14px; display: flex; justify-content: flex-end; }
.callback-section { margin-top: 18px; }
.section-title { display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px; font-weight: 600; }
.json-box { white-space: pre-wrap; word-break: break-all; max-height: 260px; overflow: auto; margin: 0; }
.report-actions { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 16px; }
.report-actions .el-button { margin-left: 0; }
</style>
